export default {"src":"/_next/static/media/facebook.9e439fcf.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};